import React, {useState,useEffect, useRef } from 'react';
import './App.css';
import { API_URL } from './config';

const TopMessageControl = ({ onClick }) => {
    const [messages, setMessages] = useState([]);
    const [showPopup, setShowPopup] = useState(false); 
    const clearMessage = () => {
        setMessages([]);
    };

    function callbackGetList (json) {
        try {
          let jsonObject = window.JSON.parse(json);
          console.log(jsonObject)
          if(jsonObject.code === 200 && jsonObject.data){
            let questions = jsonObject.data.map(item => item.question);
            console.log("原始 questions:", questions);

            // 过滤掉包含 "View all FAQs" 的项
            let filteredQuestions = questions.filter(q => q !== "View all FAQs");

            setMessages(filteredQuestions);
            console.log("过滤后 questions:", filteredQuestions);
          }
        } catch (error) {
          // 如果上面的操作抛出异常，这里的代码将会执行
          console.error('Error during data fetching:', error);
        }
      };

    const getQuestionList = async ( callback) =>
        {
          let httpRequest = new XMLHttpRequest();
          httpRequest.open('GET', `${API_URL}/commonqa/getListV1`, true);
          //httpRequest.setRequestHeader("Accept", "application/json");
          //httpRequest.setRequestHeader("Content-type", "application/json");
          httpRequest.send();
      
          httpRequest.onreadystatechange = function () {//
            if (httpRequest.readyState === 4 && httpRequest.status === 200) {
              let json = httpRequest.responseText;
              callback(json);
            }
          };
        }

    const hasCalled = useRef(false); // 标记是否已调用
    useEffect(() => {

      if(!hasCalled.current){
        hasCalled.current = true;
        clearMessage();
        getQuestionList(callbackGetList);
        // handleSendMessage('I need help setting up my hearing aid.');
        // handleSendMessage("I can't connect my hearing aid.");
        // handleSendMessage('How do I clean my hearing aid?');
        // handleSendMessage('How to use the app.');
        console.log('call useEffect')
      }
        
    }, []);

    const handleClick = (e) => {
        // 在按钮点击时调用父组件传递的回调函数，并传递当前按钮的值
        onClick(e.target.innerText);
      };

    const handleClickSubmit = (e) => {
        window.location.href = 'SubmitFeedback';
      };

    const handleClickFaq = (e) => {
        // 在按钮点击时调用父组件传递的回调函数，并传递当前按钮的值
        window.location.href = 'https://elehear.com/pages/faq'; // 替换为你想跳转的 URL
      };
    // 关闭弹窗的函数
    const handleClose = () => {
      setShowPopup(false);
    };
  return (
    <div className="container-top-left">
        <div className="top-left-aligned">
            {messages.map((msg, index) => (
                <button key={index} onClick={handleClick}>
                    {msg}
                </button>
            ))}

            <div className='div-faq'>
              <button  onClick={handleClickFaq}>
                View All FAQs
                <img
                  src={require('./img/link.svg').default}
                  alt="icon"
                  className="link-icon"
                />
              </button>
            </div>
            {/* <button className="submitFeedback"  onClick={handleClickSubmit}>
              <span>Submit Feedback</span>
              <img 
                src={require('./img/submit.svg')}
                alt="icon" 
                style={{ width: '24px', height: '24px', marginLeft: 'auto' }} 
              />
            </button> */}
           

            {showPopup && (
              <div style={{ position: 'fixed', top: '20%', left: '40%', padding: '20px', backgroundColor: 'white', border: '1px solid black' }}>
                <p>This is a simple popup</p>
                <button onClick={handleClose}>Close</button>
              </div>
            )}
        </div>

    </div>
  );
};

export default TopMessageControl;
